import ClientService from "src/services/ClientService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	uuid:"",
	name:"",
	tel:"",
	id_number:"",
	email:"",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.client,
@property  {array}  modules.clients
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator("client", ClientService, module, types ,params);
